<template>
	<AnalyticsSectionPreviewCard
		title="Top users"
		class="card-container"
		linkText="Show breakdown"
		:toRouteName="ANALYTICS_TOP_USERS_ROUTE_NAME"
	>
		<Col class="height-100 width-100">
			<AnalyticsTopUserItem
				:index="i"
				class="user-item"
				:userId="topUser.user_id"
				:numOfRuns="topUser.runs"
				v-for="(topUser, i) in topUsersToDisplay"
				:key="`topUsersToDisplay${topUser.user_id}`"
				:maxNumOfRunsOnDisplay="maxNumOfRunsOnDisplay"
				:numOfElementOnDisplay="topUsersToDisplay.length"
			/>
		</Col>
	</AnalyticsSectionPreviewCard>
</template>
<script>
import { ANALYTICS_TOP_USERS_ROUTE_NAME } from '@/router/router.const.js';
import AnalyticsMixin from '@/components/Analytics/mixins/AnalyticsMixin.js';
import AnalyticsTopUserItem from '@/components/Analytics/Cards/Items/AnalyticsTopUserItem.vue';
import AnalyticsSectionPreviewCard from '@/components/Analytics/Cards/AnalyticsSectionPreviewCard.vue';
export default {
	name: 'AnalyticsTopUsersCard',
	mixins: [AnalyticsMixin],
	components: { AnalyticsTopUserItem, AnalyticsSectionPreviewCard },
	computed: {
		maxNumOfRunsOnDisplay() {
			return Math.max(...this.topUsersToDisplay.map((item) => item.runs));
		},
		topUsersToDisplay() {
			return this.runsByUser.slice(0, this.maxNumberOfItemsInPreviewCard);
		},
	},
	data() {
		return { ANALYTICS_TOP_USERS_ROUTE_NAME };
	},
};
</script>
<style scoped lang="scss">
.card-container {
	max-height: 355px;
	min-height: 355px;
}
.user-item {
	max-height: 47px;
}
</style>
